<template>
  <v-card outlined>
    <v-card-text>
      <v-layout
        row
        :wrap="$vuetify.breakpoint.xsOnly"
        align-center
        justify-space-between
        fill-height
      >
        <v-flex xs12 sm3>
          <!-- selectedProduct: {{ selectedProduct }} -->
          <AutoComplete :rounded="false"
            :PriceTierId="priceTierId"
            @submit="productSubmitted"
            @submitMultiple="addMultipleRows"
            ref="selectedProductChild"
            @emptyEntryBar="emptyEntryBar()"
          />
        </v-flex>
        <v-flex xs12 sm3>
          <v-textarea
          v-if="
              this.currentBusiness &&
              this.currentBusiness.metadata &&
              this.currentBusiness.metadata.multiLineItemName
            "
            label="Item Name"
            :disabled="lockProductName"
            v-model="name"
            outlined
            dense
            rows="2"
            hide-details
            ref="itemName"
          />
          <v-text-field
            v-else
            label="Item Name"
            @keyup.enter="$refs.qty.focus"
            v-model="name"
            outlined
            dense
            hide-details
            autocomplete
            ref="itemName"
            :disabled="lockProductName"
          ></v-text-field>
          
        </v-flex>

        <v-flex xs4 sm1>
          <v-text-field
            class="centered-input"
            @focus="$event.target.select()"
            ref="qty"
            :disabled="disabledQty"
            label="Qty"
            outlined
            dense
            type="number"
            hide-details
            @keyup.enter="$refs.price.focus"
            v-model="qty"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 sm2>
          <v-text-field
            class="right-input"
            @keyup.enter="submit"
            ref="price"
            @focus="$event.target.select()"
            label="Price"
            v-model="price"
            outlined
            type="number"
            dense
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs4 sm2>
          <v-text-field
            class="right-input"
            ref="extAmount"
            disabled
            outlined
            dense
            hide-details
            @focus="$event.target.select()"
            v-model="total"
            label="Ext Amount"
          ></v-text-field>
        </v-flex>
        <v-flex d-flex xs12 sm1>
          <v-btn :block="$vuetify.breakpoint.xsOnly" color="info" ref="addbutton" large @click="submit">
            add
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- v-if="selectedProduct && selectedProduct.boxPrice > 0"  The box contains 6 units priced at $120.00 in total, with a unit price of $20.00. -->
      <div
        v-if="
          selectedProduct &&
          currentBusiness &&
          currentBusiness.metadata &&
          currentBusiness.metadata.boxCountOnInventory
        "
        class="text-center"
      >
        The box contains
        <span class="font-weight-bold">{{
          selectedProduct.unitCountInBox
        }}</span>
        Units priced at
        <span class="font-weight-bold">{{
          selectedProduct.price | currency
        }}</span>
        in total, with a unit price of
        <span class="font-weight-bold">{{
          (selectedProduct.price / selectedProduct.unitCountInBox) | currency
        }}</span>
      </div>
    </v-card-text>
    <v-dialog persistent v-model="dialog" max-width="650">
  <v-card :loading="loadingNumber">
    <v-toolbar dense class="mb-3"  flat color="grey lighten-3">
      <v-toolbar-title class="subtitle-1">Available Serial Numbers</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn outlined rounded small class="ma-2" @click="uploadExcelFile">
        Bulk Sale
      </v-btn>
      <v-btn small icon @click.stop.prevent="closeDialog()">
        <v-icon small>close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text class="pt-4">
      <v-row>
        <input
          type="file"
          ref="fileInput"
          @change="handleFileUpload"
          accept=".xlsx, .xls, .csv"
          style="display: none"
        />
        <v-col cols="12" class="pa-0" v-if="serialSummary.show">
          <v-alert dense text :type="serialSummary.type">
            {{ serialSummary.message }}
          </v-alert>
        </v-col>

        <v-col class="pt-1" cols="12">
          <v-text-field
            v-model="search"
            outlined
            class="mb-2"
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="serailList"
            flat
            :search="search"
            item-key="id"
            show-select
          >
            <template v-slot:item.cost="{ item }">
              {{ item.cost | currency }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="saveSerialNumbers"> Save </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <v-dialog v-model="openWeightDialog" persistent max-width="400">
      <v-card>
        <ModelTitle title="Weight Required" @close="closeWeight()" />
        <!-- <v-card-title class="headline">Weight Required</v-card-title> -->
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                class="centered-input"
                @focus="$event.target.select()"
                ref="weightQty"
                label="Quantity"
                outlined
                dense
                type="number"
                hide-details
                @keyup.enter="$refs.weight.focus"
                v-model="weightQty"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                class="centered-input"
                @focus="$event.target.select()"
                ref="weight"
                label="Total Weight"
                outlined
                dense
                type="number"
                hide-details
                @keyup.enter="$refs.weightboxPrice.focus"
                v-model="weight"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                class="right-input"
                @keyup.enter="submit"
                ref="weightboxPrice"
                @focus="$event.target.select()"
                label="Price"
                v-model="weightboxPrice"
                outlined
                type="number"
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <div class="text-center font-weight-medium">
            Total:
            <span class="font-weight-medium text--black">
              {{ (weight * weightboxPrice) | currency }}</span
            >
            <span class="ml-1"
              >Each Box:
              <span>{{
                ((weight * weightboxPrice) / weightQty) | currency
              }}</span></span
            >
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeWeight()">Close</v-btn>
          <v-btn color="primary" dark @click="weightSubmit()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showErrorMessageDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline"> Already Sold </v-card-title>
        <v-card-text>
          <div class="text-center">
            <div>
              <strong>{{ showErrorMessage }}</strong> if find this is a mistake
              click restock button to sale it
            </div>
            <div class="mt-2">
              <v-btn @click="restock" color="success">Restock</v-btn>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="showErrorMessageDialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
// import productService from "@/modules/Product/service";
import purchaseService from "@/modules/Inventory/Purchase/service";
// import customerPriceService from "@/modules/Customer/CustomerPrice/service.js";
import AutoComplete from "@/modules/Product/components/AutoComplete.vue";
import { mapGetters, mapActions } from "vuex";
import * as XLSX from 'xlsx';
// import PriceTierService from "@/modules/Product/PriceTier/service.js";

export default {
  name: "ProductSearchBar",
  // props: {
  //   selectedCustomer: {
  //     type: Object,
  //     default: {},
  //   },
  // },
  data() {
    return {
      priceTierId: null,
      weightQty: null,
      weight: null,
      weightboxPrice: 0,
      showErrorMessageDialog: false,
      showErrorMessage: null,
      search: null,
      serailList: [],
      PriceList: [],
      openWeightDialog: false,
      serialSummary: {
        show: false,
        message: '',
        type: 'success',
      },
      headers: [
        {
          text: "SERIAL NUMBER",
          align: "start",
          sortable: true,
          value: "imeiNumber",
        },
        {
          text: "COST",
          align: "end",
          sortable: true,
          value: "cost",
        },
      ],
      loadingNumber: false,

      selectedProduct: null,
      selected: [],
      name: null,
      disabledQty: false,
      boxQty: 1,
      qty: 1,
      price: 0,
      total: 0,
      dialog: false,
      // PriceTiers: null,
    };
  },
  components: {
    AutoComplete,
  },

  created() {
    this.emptyEntryBar();
    // this.getCustomerPriceList();
    // this.$events.listen("customerChange", () => this.getCustomerPriceList());
    // console.log("created ProductSearchBar", this.getSelectedCustomer);
    if (!this.currentBusiness?.metadata?.isSingleCustomerPricing && this.getSelectedCustomer?.PriceTierId) {
      this.priceTierId = this.getSelectedCustomer.PriceTierId
    //   this.getProductPrice(this.getSelectedCustomer.PriceTierId);
    }
  },
  // beforeDestroy() {
  //   this.$events.remove("customerChange");
  // },
  computed: {
    ...mapGetters("invoice", [
      "Invoice",
      "InvoiceDetails",
      "getSelectedCustomer",
    ]),
    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),
    // priceLabel() {
    //   let label = 'Price'
    //   if (this.currentBusiness?.metadata?.boxCountOnInventory ) {
    //     label = 'Price'
    //   }
    //   return label
    // },
    // lockProductName() {
    //   if (!this.currentBusiness.metadata.hasOwnProperty('lockProductName')) {
    //     return true
    //   } else if (this.currentBusiness.metadata.lockProductName) {
    //     return true
    //   }
    //   return false
    // },
    lockProductName() {
      const meta = this.currentBusiness?.metadata;
      if (!meta || !meta.hasOwnProperty("lockProductName")) {
        return true;
      }
      return !!meta.lockProductName;
    },
  },
  watch: {
    qty(val) {
      this.total = this.price * val;
    },
    price(val) {
      this.total = (this.price * this.qty).toFixed(2);
    },
    getSelectedCustomer(val) {
      // console.log("getSelectedCustomer", val);
      // if (val && val.PriceTierId) {
      //   this.getProductPrice(val.PriceTierId);
      // }
      if (!this.currentBusiness?.metadata?.isSingleCustomerPricing && val && val.PriceTierId) {
        this.priceTierId = val.PriceTierId;
      } else {
        this.priceTierId = null;
      }
    },
    selectedProduct(val) {
      if (val) {
        this.setProduct(val);

        if (val.metadata && val.metadata.weightApply) {
          this.openWeightDialog = true;
          this.weightboxPrice = this.price;
        }
      }
    },
    openWeightDialog(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.weightQty.focus();
        }, 300);
      }
    },
    dialog(val) {
      if (val) {
        this.loadingNumber = true;
        this.getSerialList(this.selectedProduct);
      }
    },
  },
  methods: {
    ...mapActions("invoice", ["AddInvoiceDetail", "UnDeleteInvoiceDetailRow"]),
    ...mapActions("global", ["PlaySound"]),
    // getProductPrice(id) {
    //   return PriceTierService.getById(id).then((response) => {
    //     this.loading = false;
    //     this.PriceTiers = response.data;
    //     return response;
    //   });
    // },
    addMultipleRows(products) {
      this.$emit("submitMultiple", products);
    },
    uploadExcelFile() {
      this.serialSummary.show = false;
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" });

          const imeisFromSheet = sheetData
            .map(row => row[0].toString().trim())
            .filter(imei => imei);

          this.processIMEIs(imeisFromSheet);

        } catch (error) {
            this.serialSummary.message = 'Error processing the file. Make sure it is a valid Excel file.';
            this.serialSummary.type = 'error';
            this.serialSummary.show = true;
        }
      };
      reader.readAsArrayBuffer(file);
      event.target.value = null;
    },

    processIMEIs(imeisFromSheet) {
      let foundCount = 0;
      const newlySelected = [];
      const serialsInTable = new Set(this.serailList.map(item => item.imeiNumber));

      for (const imei of imeisFromSheet) {
        if (serialsInTable.has(imei)) {
          const itemToSelect = this.serailList.find(item => item.imeiNumber === imei);
          if (itemToSelect) {
              newlySelected.push(itemToSelect);
              foundCount++;
          }
        }
      }

      const notFoundCount = imeisFromSheet.length - foundCount;
      this.selected = [...new Set([...this.selected, ...newlySelected])];

      if(notFoundCount){
        this.serialSummary.message = `${foundCount} serials found and selected. ${notFoundCount} serials not found.`;
        this.serialSummary.type = 'warning';
      } else {
        this.serialSummary.message = `${foundCount} serials found and selected.`;
        this.serialSummary.type = 'success';
      }
      this.serialSummary.show = true;
    },
    productSubmitted(val) {
      // console.log("productSubmitted", val);
      this.selectedProduct = val;
    },
    weightSubmit() {
      // console.log("weightSubmit");

      this.submit();
      this.openWeightDialog = false;
    },
    closeWeight() {
      this.openWeightDialog = false;
    },
    async restock() {
      const imeiNumber = this.phoneSearch;
      await purchaseService.restock({ imeiNumber: imeiNumber }).then(() => {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "success",
            title: `${imeiNumber} was restock`,
          });
        this.showErrorMessageDialog = false;
        this.phoneSearch = imeiNumber;
        this.searchIMEI();
      });
    },
    closeDialog() {
      this.dialog = false;
      this.serialSummary.show = false; 
      this.emptyEntryBar();
    },
    decrementQuantity(val) {
      if (val.qty > 1) val.qty -= 1;
    },
    incrementQuantity(val) {
      val.qty += 1;
    },

    async getSerialList(product) {
      const list = await purchaseService.getAvailableSerial({
        ProductId: product.id,
      });
      this.serailList = list.data.rows;
      this.loadingNumber = false;
    },
    setProduct(product) {
      if (product) {
        this.price = product.price;
        this.total = product.price * this.qty;

        this.name = product.name;
        this.imeiNumber = product.imeiNumber | null;
        if (product.trackSerialNumber) {
          this.disabledQty = true;
        } else {
          this.disabledQty = false;
        }
        if (product.imeiNumber) {
          setTimeout(() => {
            this.$refs.price.focus();
          }, 300);
        } else {
          setTimeout(() => {
            if (this.lockProductName) {
              this.$refs.qty.focus();
            } else {
              this.$refs.itemName.focus();
            }
          }, 300);
        }
      }
    },
    emptyEntryBar() {
      this.weight = null;
      this.weightQty = null;
      this.weightboxPrice = 0;
      this.name = null;
      this.qty = 1;
      this.boxQty = 1;
      this.total = 0;
      this.price = 0;
      this.phoneSearch = null;
      this.selectedProduct = null;
      this.dialog = false;
      this.imeiNumber = false;
      this.Products = [];
      this.selected = [];
      setTimeout(() => {
        // this.$refs.productSearch.focus();
        // console.log('selectedProductChild', this.$refs)
        this.$refs.selectedProductChild.$refs.productSearchInput.focus();
      }, 300);
      this.error = [];
      if (this.$refs?.selectedProductChild) {
        this.$refs.selectedProductChild.emptyAutoComplete();
      }
    },
    submit() {
      if (this.currentBusiness?.metadata?.lockOutOfStock) {
        if (this.selectedProduct.balance < this.qty) {
          this.PlaySound("error");
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: `${this.selectedProduct.name} current stock is ${this.selectedProduct.balance}`,
            });
          return false;
        }
      }

      if (!this.selectedProduct) return false;
      if (this.selectedProduct.trackSerialNumber) {
        this.dialog = true;
      } else {
        if (
          this.selectedProduct.metadata &&
          this.selectedProduct.metadata.weightApply
        ) {
          this.selectedProduct.weight = this.weight;
          this.selectedProduct.weightQty = this.weightQty;
          // this.selectedProduct.Bar.qty = this.weightQty
          // this.selectedProduct.Bar.price = this.weightboxPrice
          // this.selectedProduct.Bar.name = this.name + ' ' + this.weight + ' lb'
          this.selectedProduct.weightboxPrice = this.weightboxPrice;
          this.selectedProduct.weightTotalAmount =
            parseFloat(this.weightQty) * parseFloat(this.weightboxPrice);
          this.selectedProduct.cost = (
            (parseFloat(this.weight) * parseFloat(this.selectedProduct.cost)) /
            parseFloat(this.weightQty)
          ).toFixed(2);
          // console.log("weightSubmit", this.selectedProduct.cost);
          this.selectedProduct.Bar = {
            name:
              this.name +
              " " +
              this.weight +
              " lb" +
              " x " +
              this.weightboxPrice,
            qty: this.weightQty,
            price: (
              (this.weight * this.weightboxPrice) /
              this.weightQty
            ).toFixed(2),
          };
        } else {
          this.selectedProduct.Bar = {
            name: this.name,
            qty: this.qty,
            price: this.price,
            boxQty: this.boxQty,
          };
        }
        // console.log("selectedProduct", this.selectedProduct);
        this.$emit("submit", this.selectedProduct);
        this.emptyEntryBar();
      }
    },
    async saveSerialNumbers() {
      await Promise.all(
        this.selected.map((row) => {
          const imeiResult = this.InvoiceDetails.find(
            ({ imeiNumber }) => imeiNumber === row.imeiNumber
          );
          if (imeiResult) {
            this.PlaySound("error");
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: `${row.imeiNumber} is already in this list`,
              });
          } else {
            this.AddInvoiceDetail({
              ProductId: this.selectedProduct.id,
              name: this.name,
              price: this.price,
              total: this.price * 1,
              qty: 1,
              cost: row.cost | 0,
              imeiNumber: row.imeiNumber,
            });
          }
        })
      );

      this.closeDialog();
    },
  },
};
</script>

<style scoped></style>
